import {LTServices} from "../lt-ng/lt-services"
import {L} from "../lt-ng/landcare-toolkit";
import {transform} from "ol/proj";
import {IPortal} from "@esri/arcgis-rest-request";
import {IPortalServices} from "../lt-ng/portal-services";

export interface ILayerClassResource extends ng.resource.IResource<ILayerClassResource> {
	flags: number;
	id: number;
	legendOn: boolean;
	longName: string;
	param: number;
	shortName: string;

	// Although all actions defined on IArticleResourceClass are avaiable with
	// the '$' prefix, we have the choice to expose only what we will use
	$publish(): ILayerClassResource;
	$unpublish(): ILayerClassResource;
}


export interface ILegendRequestItem {
	type: 'class'|'configuration';
	id: number;
}


export interface ILegendRequest {
	request: {
		items: ILegendRequestItem[]
	}
}


export interface ILegendResponseItem {
	attributes: {};
	classColor: string;
	flags: number;
	id: number;
	layerName: string;
	legendOn: boolean;
	longName: string;
	param: number;
	shortName: string;
}
export interface ILegendResponse {
	response: ILegendResponseItem[]
}

export interface ILegendService {
	getLegend(request: ILegendRequest) : ng.IHttpPromise<ILegendResponse>;
	getLegendForNodes(nodes : L.tree.Item[]) : ng.IHttpPromise<ILegendResponse>;
}

export class LegendService implements ILegendService {
	public static $inject = ['$http', 'portalServices'];
	constructor(protected $http: ng.IHttpService, protected portalServices: IPortalServices) {

	}

	private byClassesOrConfigurationUrl = `${this.portalServices.baseUri()}/portal_configuration/layer_configuration_class`
	getLegend(request: ILegendRequest): angular.IHttpPromise<ILegendResponse> {
		return this.$http.post(this.byClassesOrConfigurationUrl, request, {
			headers: {
				'Content-Type': 'application/json'
			}
		});
	}

	getLegendForNodes(nodes: L.tree.Item[]): angular.IHttpPromise<ILegendResponse> {
		// let layerIdToNode = {};

		let request : ILegendRequestItem[] = nodes
			.filter((n) => n && (n.classId || n.layerId))
			.map((n) => {
				/*let isClass = !!n.classId;
				if (!isClass) {
					layerIdToNode["" + n.layerId] = n;
				}*/

				return <ILegendRequestItem> {
					'type': (n.classId ? 'class' : 'configuration'),
					'id': (n.classId ? n.classId : n.layerId)
				};
			});

		let otherItems : ILegendRequestItem[] = nodes
			.filter((n) => n && !(n.classId || n.layerId) && n.layerService.CLASS)
			.map((n) => {
				return n.layerService.CLASS.map<ILegendRequestItem>((c) => {
					return {
						'type': 'class',
						'id': c.id
					}
				})
			}).reduce((collection, items) => collection.concat(items), []);

		return this.getLegend({ request: { items: request.concat(otherItems) }})
	}
}

export interface IAddressSearchParameters {

}
interface IPlaceNameSearchParameters {
	name: string;
}


// Let's define a custom resource
export class AddressSearchService {
	public static url: string = 'app/addressSearch/:query';
	constructor() {

	}
}
export class SearchService {
	public static $inject = ['$http'];
	private $http: ng.IHttpService;
	public mapService: LTServices.IMapService;
	//private openLayersService: openlayersDirective.OpenLayersService;
	search: string;
	constructor($http: ng.IHttpService) {
		console.log('SearchService');
		this.$http = $http;
		//this.openLayersService = openLayersService;
	}
	logSearch(): string {
		console.log('search:', this.search);
		return this.search;
	}
	open: (search: string) => void;

	addressGoTo(pxid: string): void {
		this.$http.get('app/addressInfo/' + encodeURIComponent(pxid)).then((response) => {
			let result : { x: string, y: string } = <any> response.data;
			let lon: number = Number(result.x);
			let lat: number = Number(result.y);
			let coord = transform([lon, lat],
				'EPSG:4326', 'EPSG:2193');
			let view = this.mapService.view;
			view.setCenter(coord);
			view.setZoom(9);
		});
	}
}
export interface IAddressSearchResource extends ng.resource.IResource<ILayerClassResource> {
	// addressfinder:
	a: string;
	pxid: string;
	v: number;

	// Although all actions defined on IArticleResourceClass are avaiable with
	// the '$' prefix, we have the choice to expose only what we will use
	$publish(): IAddressSearchResource;
	$unpublish(): IAddressSearchResource;
}
